import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/app/ui/assets/svg/pin-location.svg'


const _hoisted_1 = { class: "w-11/12 py-4 mt-6 bg-white rounded-lg border border-gray-lp-1400 flex-col justify-start gap-2 inline-flex" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "w-[752px] justify-between items-center inline-flex border-b pb-4 px-6" }, [
  /*#__PURE__*/_createVNode("div", { class: "grow shrink basis-0 text-gray-lp-300 text-base font-semibold font-montserrat" }, " Alamat Pick Up ")
], -1)
const _hoisted_3 = { class: "w-[755px] justify-start items-center gap-2 inline-flex px-6" }
const _hoisted_4 = { class: "grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex" }
const _hoisted_5 = { class: "self-stretch justify-between items-center inline-flex" }
const _hoisted_6 = { class: "justify-start items-center gap-2 flex" }
const _hoisted_7 = {
  key: 0,
  class: "px-2 bg-gray-lp-200 rounded justify-center items-center gap-2 flex"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "text-center text-gray-lp-300 text-sm font-medium font-montserrat" }, " Utama ", -1)
const _hoisted_9 = { class: "text-center text-gray-lp-300 text-sm font-bold font-montserrat" }
const _hoisted_10 = { class: "flex-col justify-start items-start gap-4 flex" }
const _hoisted_11 = { class: "flex-col justify-start items-start gap-1 flex" }
const _hoisted_12 = { class: "text-left" }
const _hoisted_13 = { class: "w-[755px] text-gray-lp-300 text-sm font-semibold font-montserrat" }
const _hoisted_14 = { class: "w-[755px] text-gray-lp-300 text-sm font-normal font-montserrat" }
const _hoisted_15 = { class: "flex-col justify-start items-start gap-1 flex" }
const _hoisted_16 = { class: "w-[755px] text-gray-lp-1800 text-sm font-medium font-montserrat" }
const _hoisted_17 = { class: "w-[755px] text-gray-lp-1800 text-sm font-medium font-montserrat" }
const _hoisted_18 = { class: "w-[755px] justify-start items-end gap-1 inline-flex" }
const _hoisted_19 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4 h-4",
  alt: "up"
}, null, -1)
const _hoisted_20 = { class: "w-[755px] text-gray-lp-300 text-sm font-normal font-montserrat" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            (_ctx.data.pickupCorporateAddress.pcaIsDefault)
              ? (_openBlock(), _createBlock("div", _hoisted_7, [
                  _hoisted_8
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_9, _toDisplayString(_ctx.data.pickupCorporateAddress.pcaName), 1)
          ])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _createVNode("span", _hoisted_13, _toDisplayString(_ctx.data.pickupCorporateAddress.pcaPicName), 1),
              _createVNode("span", _hoisted_14, " - " + _toDisplayString(_ctx.data.pickupCorporateAddress.pcaPhoneNumber), 1)
            ]),
            _createVNode("div", _hoisted_15, [
              _createVNode("div", _hoisted_16, _toDisplayString(_ctx.data.pickupCorporateAddress.pcaDistrictName), 1),
              _createVNode("div", _hoisted_17, _toDisplayString(_ctx.data.pickupCorporateAddress.pcaAddress), 1)
            ])
          ]),
          _createVNode("div", _hoisted_18, [
            _hoisted_19,
            _createVNode("div", _hoisted_20, " Titik koordinat : " + _toDisplayString(_ctx.data.pickupCorporateAddress.pcaLatlon), 1)
          ])
        ])
      ])
    ])
  ]))
}